// The user's changes that a 409 stale_version replaced with the question as it is now: kept, so that "Restore my
// changes" can put them back into the reloaded form. Only the fields the user changed go back: a field someone
// else changed meanwhile, and the user did not, keeps its new value.

const text = (value) => value || '';
const orNull = (value) => value || null;
const optionsOf = (question) =>
  JSON.stringify((question?.answer_keys || []).map((key) => [key.option, text(key.body), !!key.is_correct]));

// The fields the edit form changes, each with the form's keys that go with it: a picker's shown name goes with
// its uuid, and the subtopic with its topic (another topic empties it).
const FIELDS = [
  { keys: ['name'], same: (a, b) => text(a.name) === text(b.name) },
  { keys: ['body'], same: (a, b) => text(a.body) === text(b.body) },
  { keys: ['difficulty'], same: (a, b) => orNull(a.difficulty) === orNull(b.difficulty) },
  { keys: ['purpose'], same: (a, b) => orNull(a.purpose) === orNull(b.purpose) },
  { keys: ['objective'], same: (a, b) => orNull(a.objective) === orNull(b.objective) },
  {
    keys: ['topic', 'topic_name', 'subtopic', 'subtopic_name'],
    same: (a, b) => orNull(a.topic) === orNull(b.topic) && orNull(a.subtopic) === orNull(b.subtopic),
  },
  { keys: ['answer_keys'], same: (a, b) => optionsOf(a) === optionsOf(b) },
];

// What `question` changed of `base` (the form as opened): {key: value} of the changed fields, null when nothing.
export const changedFields = (base, question) => {
  const changes = {};
  FIELDS.forEach(({ keys, same }) => {
    if (same(base || {}, question || {})) return;
    keys.forEach((key) => {
      changes[key] = question?.[key];
    });
  });
  return Object.keys(changes).length ? changes : null;
};

// The kept `edits` the form's `question` does not have now (null when none): what "Restore my changes" puts back.
export const editsToRestore = (edits, question) => (edits ? changedFields(question, { ...question, ...edits }) : null);
